/* @flow */

import React, { Component } from 'react';

import { isBrowsersOptimal } from '../../base/environment';
import { translate } from '../../base/i18n';

import { CHROME, FIREFOX, SAFARI } from './browserLinks';

/**
 * The namespace of the CSS styles of UnsupportedDesktopBrowser.
 *
 * @private
 * @type {string}
 */
const _SNS = 'unsupported-desktop-browser';

/**
 * The type of the React {@code Component} props of
 * {@link JaasUnsupportedDesktopBrowser}.
 */
type Props = {

    /**
     * The function to translate human-readable text.
     */
    t: Function
};

/**
 * React component representing unsupported browser page.
 *
 * @class UnsupportedDesktopBrowser
 */
class JaasUnsupportedDesktopBrowser extends Component<Props> {
    /**
     * Renders the component.
     *
     * @returns {ReactElement}
     */
    render() {
        return (
            <div className = { _SNS } style={{ marginTop: "-50px" }}>
                <img src='/images/remotepc-logo.png' width={200}/>
                <h2 className = { `${_SNS}__title` } style={{ color: "#494949" }}>
                    RemotePC Meeting doesn't support your browser
                </h2>
                <p className = { `${_SNS}__description` } style={{ fontSize: "16px", color: "#333", marginBottom: "30px" }}>
                    You are visiting this page because we detected an unsupported browser. We highly recommend that you update your browser.
                    {/* <a
                        className = { `${_SNS}__link` }
                        href = { CHROME } >Chrome</a>&nbsp;
                    {
                        this._showFirefox() && <>or <a
                            className = { `${_SNS}__link` }
                            href = { FIREFOX }>Firefox</a></>
                    } */}
                </p>
                <div style={{
                    boxSizing: "border-box",
                    width: "100%",
                    background: "#fff",
                    padding: "31px 25px",
                    borderRadius: "5px",
                    boxShadow: "5px 8px 17px 9px rgb(80 119 144 / 15%)",
                    margin: "0",
                    display: "",
                    alignItems: "stretch",
                }}>
                    {/* Install Latest */}
                    <br/>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                        <a className = { `${_SNS}__link` } href = { CHROME } >
                            <img src = 'https://upload.wikimedia.org/wikipedia/commons/8/87/Google_Chrome_icon_%282011%29.png' width={60} style={{marginBottom: "10px"}} /> <br/>
                            Chrome
                        </a>
                        {/* <a className = { `${_SNS}__link` } href = { FIREFOX } >
                            <img src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Firefox_logo%2C_2019.svg/640px-Firefox_logo%2C_2019.svg.png' width={55} style={{marginBottom: "10px"}} /> <br/>
                            Firefox
                        </a> */}
                        <a className = { `${_SNS}__link` } href = { SAFARI } >
                            <img src = 'https://pngimg.com/uploads/safari/safari_PNG1.png' width={55} style={{marginBottom: "10px"}} /> <br/>
                            Safari
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * Returns whether or not a link to download Firefox is displayed.
     *
     * @private
     * @returns {boolean}
     */
    _showFirefox() {
        return isBrowsersOptimal('firefox');
    }
}

export default translate(JaasUnsupportedDesktopBrowser);
